/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import CheckboxComponnet from '@components/checkbox/checkbox.component';
import Modal from '@components/modal';

import './add-fields-modal.scss';
import style from './style.module.scss';
import SearchField from '@components/search-field';

const AddFieldsModal = ({
  text,
  fields,
  onSubmit,
  openModal,
  setOpenModal,
  isEquipment = false
}) => {
  const [selectedFields, setSelectedFields] = useState(
    fields.map((el) => ({ ...el, checked: el?.checked || false }))
  );
  const [copyList, setCopyList] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setSelectedFields(fields.map((el) => ({ ...el, checked: el?.checked || false })));
    setCopyList(fields.map((el) => ({ ...el, checked: el?.checked || false })));
  }, [fields]);

  const onClick = () => {
    const data = copyList.filter(({ checked }) => checked).map(({ Id }) => Id) || [];

    let selectedIds = [];
    // if (inputValue?.trim() !== '') {
    for (let cat of fields) {
      if (data?.includes(cat.Id)) {
        selectedIds.push(cat.Id);
      }
    }
    // } else {
    //   selectedIds = data;
    // }
    onSubmit(selectedIds);
    setOpenModal(false);
  };

  const handleUserInput = (e) => {
    const valueSearched = (e && e.target.value) || '';

    setInputValue(valueSearched);

    const normalizedInput = valueSearched.replace(/\s+/g, '').toLowerCase();

    const copySelectedFields = [...copyList];
    const newList = copySelectedFields.filter((item) => {
      const normalizedItem = item.Value.replace(/\s+/g, '').toLowerCase();
      return new RegExp(normalizedInput, 'i').test(normalizedItem);
    });
    setSelectedFields(newList);
    if (!normalizedInput && newList?.length === 0 && copyList?.length > 0) {
      setSelectedFields(copyList);
    }
  };

  const disabledSaveBtn = useMemo(() => {
    if (copyList?.length > 0 && isEquipment) {
      return copyList?.find((x) => x?.checked) ? false : true;
    }
    return true;
  }, [isEquipment, copyList]);

  return (
    <div>
      <Modal
        open={openModal}
        setOpen={setOpenModal}
        statusText={'Add field(s)'}
        textBtn={isEquipment ? '' : 'Add field(s)'}
        textBtnForAddNewEquipmentFields={isEquipment ? 'Save' : ''}
        CloseBtnText={'Cancel'}
        CloseBtnClass={'op-anchor-link'}
        ActionbtnClass={`btn-fill button-large actionButton modal-btn-height ${
          isEquipment ? '' : style.actionBtn
        }`}
        Action={onClick}
        isTextBtnDisabled={disabledSaveBtn}
      >
        {' '}
        <PopupSubTitle
          text={text}
          selectedFields={selectedFields}
          setSelectedFields={(Id, checked) => {
            let copyList1 = [...copyList];
            const index = copyList1.findIndex((x) => x?.Id === Id);
            copyList1[index] = {
              ...copyList1[index],
              checked
            };
            setCopyList(copyList1);
          }}
          isEquipment={isEquipment}
          handleUserInput={handleUserInput}
          inputValue={inputValue}
        />{' '}
      </Modal>
    </div>
  );
};

const PopupSubTitle = ({
  text,
  selectedFields,
  setSelectedFields,
  isEquipment,
  handleUserInput,
  inputValue
}) => {
  const onChange = (e, index, Id) => {
    const copy = [...selectedFields];
    copy[index].checked = e.target.checked;
    setSelectedFields(Id, e.target.checked);
  };

  const title = isEquipment
    ? 'Select the fields from the list below. Only a subset of Oplii fields are available and cached for offline use.'
    : `Select the fields you want to add to your ${text.toLowerCase()} cards. Oplii only caches
        certain fields for offline use, which is why this list is limited.`;

  return (
    <div>
      <p
        className={`${isEquipment ? style.equipmentAddFieldModalTitle : 'body-regular mb-8'} `}
        style={{ textAlign: 'center' }}
      >
        {title}
      </p>
      {isEquipment && (
        <div
          style={{
            marginBottom: '16px'
          }}
        >
          <SearchField
            placeholder={isEquipment ? 'Search fields' : 'Search'}
            value={inputValue}
            onChange={handleUserInput}
            isClearable
          />
        </div>
      )}
      <div className="fields">
        {selectedFields.map(({ Value, checked, isFieldCheckedAndDisabled = false, Id }, index) => (
          <React.Fragment key={index}>
            <CheckboxComponnet
              mainClassName="mainCheckbox"
              text={Value}
              labelClassName={'labelCheckbox'}
              checked={isFieldCheckedAndDisabled || checked}
              onChange={(e) => onChange(e, index, Id)}
              addFieldModal
              disabled={isFieldCheckedAndDisabled}
            />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

AddFieldsModal.propTypes = {
  text: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  openModal: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default AddFieldsModal;
